import { cn } from "@/lib/utils";

/**
 * Two rounded corner brackets (top-right and bottom-left) framing the active
 * navigation link, as in the Figma navbar.
 */
export function CornerBrackets({ className }: { className?: string }) {
  return (
    <span aria-hidden className={cn("pointer-events-none absolute", className)}>
      <span className="absolute -top-0.5 -right-0.5 size-2.5 rounded-tr-[0.3125rem] border-t border-r border-foreground/90" />
      <span className="absolute -bottom-0.5 -left-0.5 size-2.5 rounded-bl-[0.3125rem] border-b border-l border-foreground/90" />
    </span>
  );
}
